<template>
    <Card>
        <div class="ql-editor" v-html="lesson.translation.description"></div>
    </Card>
</template>

<script>
import Card from '../../../../argon/components/Cards/Card';

export default {
    name: 'OptionsOverview',
    components: {
        Card,
    },
    props: {
        lesson: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>
